import api from '../utils/api';

export const DOWLOAD_PAGE_URL = '/download';
export const HOME_PAGE_URL = '/';

export const getDownloadPageUrl = (fn: string) => `${DOWLOAD_PAGE_URL}/?fn=${fn}`;
export const getFileUrl = (fn: string) => `${api.defaults.baseURL}api/download/?fn=${encodeURIComponent(fn)}`;
